"use client";

import React from "react";
import { twMerge } from "tailwind-merge";

import Icon from "@/components/icon";

interface ToggleEditIconProps {
  className?: string;
  isEditing?: boolean;
  onToggle?: () => void;
}

function ToggleEditIcon({
  className,
  isEditing,
  onToggle,
}: ToggleEditIconProps) {
  return (
    <div
      onClick={onToggle}
      className={twMerge(
        "bg-secondary text-white hover:bg-white hover:text-secondary rounded-full h-8 flex items-center justify-center cursor-pointer w-8",
        className,
      )}
    >
      <Icon icon={isEditing ? "cross" : "meeting-modif"} size={15} />
    </div>
  );
}

export default ToggleEditIcon;
